import Vue from 'vue'
import vuex from 'vuex'

import app from './modules/app'
import menu from './modules/menu'
import tab from './modules/tab'
import baseProvinceList from './modules/baseProvinceList'
import partnersList from './modules/partnersList'

Vue.use(vuex)

const store = new vuex.Store({
    modules: {
        app,
        menu,
        tab,
        baseProvinceList,
        partnersList
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js